function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { UIPlugin } from '@uppy/core';
var packageJson = {
  "version": "3.0.3"
};
/* eslint-disable max-len */
/**
 * Add Redux DevTools support to Uppy
 *
 * See https://medium.com/@zalmoxis/redux-devtools-without-redux-or-how-to-have-a-predictable-state-with-any-architecture-61c5f5a7716f
 * and https://github.com/zalmoxisus/mobx-remotedev/blob/master/src/monitorActions.js
 */
/* eslint-enable max-len */
var ReduxDevTools = /*#__PURE__*/function (_UIPlugin) {
  _inherits(ReduxDevTools, _UIPlugin);
  function ReduxDevTools(uppy, opts) {
    var _this;
    _classCallCheck(this, ReduxDevTools);
    _this = _callSuper(this, ReduxDevTools, [uppy, opts]);
    _this.type = 'debugger';
    _this.id = _this.opts.id || 'ReduxDevTools';
    _this.title = 'Redux DevTools';

    // set default options
    var defaultOptions = {};

    // merge default options with the ones set by user
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _this.handleStateChange = _this.handleStateChange.bind(_assertThisInitialized(_this));
    _this.initDevTools = _this.initDevTools.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ReduxDevTools, [{
    key: "handleStateChange",
    value: function handleStateChange(prevState, nextState) {
      this.devTools.send('UPPY_STATE_UPDATE', nextState);
    }
  }, {
    key: "initDevTools",
    value: function initDevTools() {
      var _this2 = this;
      this.devTools = window.devToolsExtension.connect();
      this.devToolsUnsubscribe = this.devTools.subscribe(function (message) {
        if (message.type === 'DISPATCH') {
          // Implement monitors actions
          switch (message.payload.type) {
            case 'RESET':
              _this2.uppy.cancelAll();
              return;
            case 'IMPORT_STATE':
              {
                var computedStates = message.payload.nextLiftedState.computedStates;
                _this2.uppy.store.state = _objectSpread(_objectSpread({}, _this2.uppy.getState()), computedStates[computedStates.length - 1].state);
                _this2.uppy.updateAll(_this2.uppy.getState());
                return;
              }
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
              _this2.uppy.store.state = _objectSpread(_objectSpread({}, _this2.uppy.getState()), JSON.parse(message.state));
              _this2.uppy.updateAll(_this2.uppy.getState());
              break;
            default:
          }
        }
      });
    }
  }, {
    key: "install",
    value: function install() {
      // eslint-disable-next-line no-underscore-dangle
      this.withDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
      if (this.withDevTools) {
        this.initDevTools();
        this.uppy.on('state-update', this.handleStateChange);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (this.withDevTools) {
        this.devToolsUnsubscribe();
        this.uppy.off('state-update', this.handleStateUpdate);
      }
    }
  }]);
  return ReduxDevTools;
}(UIPlugin);
export { ReduxDevTools as default };
ReduxDevTools.VERSION = packageJson.version;